
<template>
    
        <mars-view :class="['modal-container', appear === 'center' ? 'modal-center' : '']" :style="{
        display: isShow ? 'block' : 'none',
        zIndex: zindex,
    }"><mars-view v-if="shadow !== 'none'" :class="['shadow', shadowAnimation]" @click.native.stop="onShadowTap"></mars-view><mars-view :class="['main-content', appear === 'center' ? 'center-box' : 'around-box', appearAnimation]"><slot></slot></mars-view></mars-view>
    
</template>

<script>
/* globals getApp, Page, swan */

export default {
  props: {
    // 是否展现弹窗
    show: {
      type: Boolean,
      value: false
    },
    // 弹窗背景效果,default:有
    shadow: {
      type: String,
      default: 'default'
    },
    // 弹窗的类型,bottom: 底部弹窗,center: 中间弹窗
    appear: {
      type: String,
      default: 'bottom'
    },
    zindex: {
      type: Number,
      default: 99
    },
    shadowClose: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show() {
      this.toggle();
    }
  },
  data() {
    return {
      isShow: false,
      // 背景动画
      shadowAnimation: '',
      // 弹窗动画
      appearAnimation: ''
    };
  },
  mounted() {
    if (this.show) {
      this.toggle();
    }
  },
  methods: {
    toggle() {
      let isShow = this.show;
      let appear = this.appear;
      this.appearAnimation = isShow ? `${appear}-in` : `${appear}-out`;
      if (this.shadow === 'default') {
        this.shadowAnimation = isShow ? 'shadow-in' : 'shadow-out';
      }
      setTimeout(() => {
        this.isShow = isShow;
      }, isShow ? 0 : 400);
    },
    onShadowTap() {
      if (!this.shadowClose) {
        return;
      }
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.modal-container {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 99;
}
.modal-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.modal-container .shadow {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.65);
  transition: opacity 0.16s cubic-bezier(0, 0, 0.3, 1);
}
.main-content {
  -webkit-overflow-scrolling: touch;
  border-top-left-radius: 13px;
  border-top-right-radius: 13px;
  overflow: hidden;
  background-color: #fff;
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
}
.modal-container .around-box {
  position: fixed;
  bottom: 0;
  max-height: 80%;
  overflow: auto;
  width: 100%;
}
.modal-container .center-box {
  margin: 0 auto;
}
/* 背景出现 */
.modal-container .shadow-in {
  animation: shadowIn 0.25s;
  animation-fill-mode: forwards;
}
.modal-container .shadow-out {
  animation: shadowOut 0.25s;
  animation-fill-mode: forwards;
}
@keyframes shadowIn {
  from {
    background-color: #0000;
  }
  to {
    background-color: #0000007f;
  }
}
@keyframes shadowOut {
  from {
    background-color: #0000007f;
  }
  to {
    background-color: #0000;
  }
}
/* 下方弹出 */
.bottom-in {
  animation: appearBottomIn 0.25s;
  animation-fill-mode: forwards;
}
.bottom-out {
  animation: appearBottomOut 0.25s;
  animation-fill-mode: forwards;
}
@keyframes appearBottomIn {
  from {
    bottom: -100%;
  }
  to {
    bottom: 0;
  }
}
@keyframes appearBottomOut {
  from {
    bottom: 0;
  }
  to {
    bottom: -100%;
  }
}
/* 中间弹出 */
.center-in {
  animation: appearCenterIn 0.25s;
  animation-fill-mode: forwards;
}
.center-out {
  animation: appearCenterOut 0.25s;
  animation-fill-mode: forwards;
}
@keyframes appearCenterIn {
  from {
    transform: scale(0.7, 0.7);
    opacity: 0;
  }
  to {
    transform: scale(1, 1);
    opacity: 1;
  }
}
@keyframes appearCenterOut {
  from {
    transform: scale(1, 1);
    opacity: 1;
  }
  to {
    transform: scale(0.7, 0.7);
    opacity: 0;
  }
}

</style>
